import React from 'react';
import {Context} from "../index";
import LocationService from "../services/locationService";
import Loader from "../ui/loader/loader";
import Container from "../ui/container/container";
import Cart from "../ui/cart/cart";
import BottomMenu from "../ui/menu/bottomMenu";
import Button from "../ui/button/button";
import Bar from "../ui/bar/bar";
import {adminSettingMenu} from "../routes/menu";
import {useLocation} from "react-router-dom";
import {observer} from "mobx-react-lite";
import Moment from "react-moment";

const LocationComponent = observer(() => {
    const {location} = React.useContext(Context);
    const page = useLocation();

    const [error, setError] = React.useState('');
    const [loader, setLoader] = React.useState(true);

    React.useEffect(() => {
        LocationService.getLocations()
            .then(data => {
                location.setLocations(data);
            })
            .catch(err => {
                setError(err.response.data.message);
            })
            .finally(() => {
                setLoader(false);
            })
    }, [location]);

    if (loader){
        return <Loader/>
    }

    return (
        <div>
            {
                error && <p>{error}</p>
            }
            <Bar>
                <ul>
                    {
                        adminSettingMenu.map(
                            item => <li key={item.id} className={page.pathname === item.url && 'active'}>
                                <Button to={item.url} variant={'linkText'}>{item.title}</Button>
                            </li>
                        )
                    }
                </ul>
            </Bar>
            <Container
                variant={'leftBar'}
            >
                <div className="flex fw-wrap">
                    {
                        location.isLocations.rows.map(
                            item =>
                                <Cart
                                    key={item.id}
                                    variant={'link'}
                                    type={'button'}
                                    buttonText={'Перейти'}
                                    to={'/locations/' + item.id}
                                >
                                    <div className="name">
                                        <span>Имя:</span>
                                        <p>{item.name}</p>
                                    </div>
                                    <div className="role">
                                        <span>Добавлен(а):</span>
                                        <p><Moment format={'YYYY.MM.DD HH:mm:ss'}>{item.createdAt}</Moment></p>
                                    </div>
                                </Cart>
                        )
                    }
                </div>
            </Container>
            <BottomMenu>
                <div className="count">
                    <span>Всего: </span><p>{location.isLocations.count}</p>
                </div>
                <div className="addButton"></div>
            </BottomMenu>
        </div>
    );
});

export default LocationComponent;